interface IShouldHaveExtendedCard {
  isDesktop: boolean;
  total: number;
}
/** На десктопе при количестве карточек большем 2 первую карточку показываем широкой **/
export const shouldHaveExtendedCard = ({ isDesktop, total }: IShouldHaveExtendedCard) =>
  isDesktop && (total === 1 || total > 2);
